import { ShieldCheck } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function Disclosure({ className = "" }) {
    const { t } = useT();
    return (
        <div
            data-testid="compliance-disclosure"
            className={`glass rounded-2xl p-4 sm:p-5 flex gap-3 text-xs sm:text-sm text-slate-300 leading-relaxed ${className}`}
        >
            <ShieldCheck className="w-5 h-5 text-emerald-300 shrink-0 mt-0.5" />
            <p>
                <strong className="text-white">{t("disclosure_strong")}</strong> {t("disclosure_body")}
            </p>
        </div>
    );
}
